exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#payment-area[data-v-b4b89eb2] {\n    width: 500px;\n}\n.btn[data-v-b4b89eb2] {\n    margin: 15px auto 0;\n    display: block;\n    width: 200px;\n}\n", ""]);

// exports
